import { observer } from 'mobx-react-lite'
import type { LegendEditorViewModel } from '@/features/legends/LegendEditor/LegendEditorViewModel'
import { VersionNotes } from '@/features/legends/options/components/VersionNotes'

export interface VersionNotesContainerProps {
  vm: LegendEditorViewModel
}

const testId = 'legend-version-notes'

/**
 * The notes of the version being viewed, when it is an older published one.
 */
export const VersionNotesContainer = observer(function VersionNotesContainer({
  vm,
}: VersionNotesContainerProps) {
  const version = vm.legendVersion
  if (!version?.published || !vm.versionsVm.isViewingPreviousVersion) {
    return null
  }
  return (
    <VersionNotes
      name={version.name}
      version={version.version}
      status={vm.versionsVm.getVersionStatus(version)}
      datePublished={version.datePublished}
      publishedBy={version.lastUpdatedBy?.displayName}
      notes={version.versionNotes}
      testId={testId}
    />
  )
})
